<div
  class="card border-bottom-primary shadow py-1 bloque-8"
  [style.color]="borderBottomColor"
>
  <div class="card-body">
    <div class="row no-gutters align-items-center">
      <div class="col-12 mr-2">
        <div class="text-secondary text-uppercase text-xs mb-1">
          <i [class]="icon"></i>
          {{ title }}

        </div>
      </div>
      <div class="col-12" [title]="tooltip1">
        <div class="h5 mb-0 font-weight-bold text-gray-800" *ngIf="!isLoading">{{ value }}</div>
        <p-skeleton width="5em" *ngIf="isLoading" />
      </div>
      <div class="col-12 p-1 mt-2">
        <p-skeleton height="10em" *ngIf="isLoading" />
      </div>

      <div class="col-6" [title]="tooltip2" *ngIf="!isLoading">
        <div
          class="mini-alert alert-primary"
          [style.color]="detailColor"
          [style.background-color]="detailBackgroundColor"
        >
          <span>{{ detailValue }}</span
          ><br />
          <span>{{ detailTitle }}</span>
        </div>
      </div>
      <div class="col-6 bar-chart" [title]="tooltip3"  *ngIf="!isLoading">
        <p-chart type="bar" [data]="data" [options]="options" class="bar-chart"/>
      </div>
    </div>
  </div>
</div>
